/**
 * 动画更新模式
 */
export enum AnimatorUpdateMode {
    /**正常更新。*/
    Normal = 0,
    /**低频率更新 */
    LowFrame = 1,
    /**不更新 */
    UnScaleTime = 2
}
